import swal from "sweetalert";

document.addEventListener("DOMContentLoaded", () => {
	$.nette.ext("product-added-alert", {
		success: function (e) {
			if (e.hasOwnProperty("showProductAdded")) {
				const count = e.showProductAdded;

				if (count > 0) {
					const message = count === 1 ? "kus přidán do košíku" : (count >= 2 && count <= 4 ? "kusy přidány do košíku" : "kusů přidáno do košíku");

					swal({
						title: count + " " + message,
						icon: "success",
						button: {
							text: "OK",
							className: "btn btn-primary",
							closeModal: true,
							value: true,
							visible: true
						},
						closeOnEsc: true,
						closeOnClickOutside: true,
						timer: 200000
					});
				} else {
					swal({
						title: "Produkt nelze přidat",
						text: "Požadované množství není skladem",
						icon: "warning",
						button: {
							text: "OK",
							className: "btn btn-primary",
							closeModal: true,
							value: true,
							visible: true
						},
						closeOnEsc: true,
						closeOnClickOutside: true,
						timer: 200000
					});
				}
			}

			if (e.hasOwnProperty("totalCartProducts")) {
				const total = e.totalCartProducts;

				$(".total-cart-products").html((total < 10 ? "&nbsp;" : "") + total);

				if (total >= 10) {
					$(".total-cart-products-10").removeClass("d-none");
					$(".total-cart-products-1").addClass("d-none");
				} else {
					$(".total-cart-products-10").addClass("d-none");
					$(".total-cart-products-1").removeClass("d-none");
				}
			}
		}
	});
});
